export class Gender {
  id: number;
  code: string;
  name: string;
}
